const initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(resolve => {
    window.addEventListener('gorgias-widget-loaded', () => {
      resolve()
    })
  })

initGorgiasChatPromise.then(async () => {
  const gorgiasTrigger = document.querySelector('.js-GorgiasTrigger')
  gorgiasTrigger.addEventListener('click', window.GorgiasChat.open)
})
